export const formatSizeFromBytes = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / k ** i) * 100) / 100} ${sizes[i]}`;
};

export const formatSizeFromGigabytes = (size: number): string => {
  if (size === 0) return '0 GB';
  const k = 1024;
  const sizes = ['kB', 'MB', 'GB', 'TB'];
  // Adjust to kB as base unit (size in GB * 1000000 = kB)
  const sizeInKB = size * 1000000;
  const i = Math.floor(Math.log(sizeInKB) / Math.log(k));
  return `${Math.round((sizeInKB / k ** i) * 100) / 100} ${sizes[i]}`;
};
